/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateItem = `subscription OnCreateItem {
  onCreateItem {
    id
    name
    description
    category
    cost
    vendor
    itemNumber
    location
    vendorLink
    nwItemNumber
    swItemNumber
    imageUrl
  }
}
`;
export const onUpdateItem = `subscription OnUpdateItem {
  onUpdateItem {
    id
    name
    description
    category
    cost
    vendor
    itemNumber
    location
    vendorLink
    nwItemNumber
    swItemNumber
    imageUrl
  }
}
`;
export const onDeleteItem = `subscription OnDeleteItem {
  onDeleteItem {
    id
    name
    description
    category
    cost
    vendor
    itemNumber
    location
    vendorLink
    nwItemNumber
    swItemNumber
    imageUrl
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/subscriptions.js